// if search-param id is null or '', redirect urls
export const RedirectURL = {
  PC: 'https://www.capcut.com/templates' as const,
  MOBILE: 'https://www.capcut.com' as const,
};
